import gql from "graphql-tag";

const queryUpdateEmployeeMainShift = gql`
  mutation($id: ID!, $workShiftId: ID) {
    updateEmployee(id: $id, data: { workShiftId: $workShiftId }) {
      id
      workShiftId
      workShift {
        id
        title
        dayInWeeks
        startTime
        endTime
        startBreakTime
        endBreakTime
        code
        duration
      }
    }
  }
`;

const queryCreateEmployee = gql`
  mutation(
    $code: String!
    $email: String
    $fullname: String!
    $birthday: DateTime
    $startedDate: DateTime
    $gender: String
    $positionId: ID
    $departmentId: ID
    $branchLocationId: ID
    $workShiftId: ID
    $userId: ID
    $codeDepartment: String
    $costCenter: String
  ) {
    createEmployee(
      data: {
        code: $code
        email: $email
        fullname: $fullname
        birthday: $birthday
        startedDate: $startedDate
        gender: $gender
        positionId: $positionId
        departmentId: $departmentId
        workShiftId: $workShiftId
        branchLocationId: $branchLocationId
        userId: $userId
        costCenter: $costCenter
        codeDepartment: $codeDepartment
      }
    ) {
      id
      code
      email
      fullname
      birthday
      startedDate
      gender
      costCenter
      codeDepartment
      concurrentPositions {
        id
      }
      position {
        id
        name
      }
      department {
        id
        name
      }

      user {
        id
        fullname
      }
      author {
        id
        fullname
      }
      branchLocationId
      branchLocation {
        id
        name
      }
      workShiftId
      workShift {
        id
        title
      }
      createdAt
      updatedAt
    }
  }
`;

const queryUpdateEmployee = gql`
  mutation(
    $id: ID!
    $code: String!
    $email: String
    $fullname: String!
    $birthday: DateTime
    $startedDate: DateTime
    $gender: String
    $phone: String
    $positionId: ID
    $departmentId: ID
    $userId: ID
    $branchLocationId: ID
    $workShiftId: ID
    $codeDepartment: String
    $costCenter: String
  ) {
    updateEmployee(
      id: $id
      data: {
        code: $code
        email: $email
        fullname: $fullname
        birthday: $birthday
        startedDate: $startedDate
        gender: $gender
        phone: $phone
        positionId: $positionId
        departmentId: $departmentId
        userId: $userId
        branchLocationId: $branchLocationId
        workShiftId: $workShiftId
        costCenter: $costCenter
        codeDepartment: $codeDepartment
      }
    ) {
      id
      code
      costCenter
      codeDepartment
      email
      fullname
      birthday
      startedDate
      gender
      phone
      concurrentPositions {
        id
      }
      position {
        id
        name
        status
      }
      department {
        id
        name
        status
      }
      user {
        id
        fullname
        username
        email
      }
      author {
        id
        fullname
      }
      branchLocation {
        id
        name
        mainShift {
          id
          title
          dayInWeeks
          startTime
          endTime
          startBreakTime
          endBreakTime
          code
          duration
        }
      }
      branchLocationId
      workShift {
        id
        title
        dayInWeeks
        startTime
        endTime
        startBreakTime
        endBreakTime
        code
        duration
      }
      workShiftId
      createdAt
      updatedAt
    }
  }
`;

const queryDeleteEmployee = gql`
  mutation($id: ID!) {
    deleteEmployee(id: $id) {
      id
    }
  }
`;
const unAssignUserFromEmployee = gql`
  mutation($id: ID!) {
    unAssignUserFromEmployee(id: $id) {
      id
      user {
        id
        fullname
        username
        email
      }
    }
  }
`;

export default {
  queryCreateEmployee,
  queryUpdateEmployee,
  queryDeleteEmployee,
  unAssignUserFromEmployee,
  queryUpdateEmployeeMainShift,
};
